<div
  class="toolbar"
  fxLayout="row"
  fxLayoutAlign="space-between"
>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <fury-toolbar-sidenav-mobile-toggle
      (openSidenav)="openSidenav.emit()"
    ></fury-toolbar-sidenav-mobile-toggle>
  </div>

  <div
    fxLayout="row"
    [class.expand-search]="showSearch"
  >
    @if (!showSearch) {
    <div
      flex="grow"
      style="padding-left: 16px"
    >
      {{ title }}
    </div>
    <fury-toolbar-user class="toolbar-button"></fury-toolbar-user>
    }

    <div
      class="search-container"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <!-- Search Toggle Button -->
      <button
        mat-icon-button
        aria-label="Toggle search input"
        (click)="toggleSearch()"
        [class.remove-border]="showSearch"
        [class.visibility]="showLoader"
      >
        <mat-icon
          matTooltip="Search Shortcut: Alt+S"
          [matTooltipPosition]="'left'"
          >search</mat-icon
        >
      </button>

      <!-- Autocomplete Search -->
      @if (showSearch) {
      <mat-form-field
        class="search-autocomplete expand-search"
        floatLabel="never"
        appearance="outline"
      >
        <input
          type="text"
          matInput
          placeholder="Search"
          cdkFocusInitial
          [formControl]="searchControl"
          [matAutocomplete]="auto"
          #searchBox
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="displayWith"
          (optionSelected)="selectSearchItem($event.option.value)"
        >
          @for (item of filteredItems | async; track $index) {
          <mat-option [value]="item">
            <span class="square mat-accent"></span>
            <span>{{ item.title }}</span>
            @if (item.subTitle && item.title !== item.subTitle) {
            <span class="search-subtitle"> - {{ item.subTitle }} </span>
            }
          </mat-option>
          } @empty {
            @if (hasSearchTerm && !isSearching && hasSearched) {
            <mat-option disabled>
              No results matching "{{ searchControl.value }}" were found.
            </mat-option>
            }
          }
        </mat-autocomplete>
      </mat-form-field>
      <button
        mat-icon-button
        aria-label="Collapse Search Bar"
        (click)="toggleSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
      }
    </div>

    @if (!showSearch) {
    <fury-toolbar-quickpanel-toggle
      (openQuickPanel)="openQuickPanel.emit()"
      class="toolbar-button"
    ></fury-toolbar-quickpanel-toggle>
    }
  </div>
</div>
